import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cms654535: FaireProductEntity = {
  token: "p_7cms654535",
  type: "product",
  name: "Golden Garden Slip Maxi Dress",
  brandToken: "b_54zek68l8m",
  brandName: "Nuvula",
  imageUrl:
    "https://cdn.faire.com/fastly/ae3a9add4248b503d676b146fdfc3daa9a20278d4cdbfcd7c7686f65397fa5a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98393136cf0bf458f9fd5abc681504c2f2d7a80809a39a771f0160ab1d5dc104.jpeg",
    "https://cdn.faire.com/fastly/7a3c7087a8065d0ab117242103c5a6e5a835381fe0de1ed3c68f002b2ae5c8a1.jpeg",
    "https://cdn.faire.com/fastly/f5600a15b7431355423e071fcc5a9248f26ebb1cc5b420a702bb3796e80f8015.jpeg",
    "https://cdn.faire.com/fastly/f93b096e4ea95d6aeee1c67763061e818665c5756ac892ff04ef8203e3c8492c.jpeg",
  ],
  priceDollars: 89,
  description:
    "The Golden Garden Slip Maxi Dress features one of Nuvula’s signature botanical illustrations, where layered florals unfold across a vibrant, psychedelic inspired composition. The all over print transforms the silhouette into a striking canvas of color and movement.\n\nDesigned with an effortless drape, the dress skims the body with a natural, easy fit. A soft U neckline and sleeveless cut create a light, versatile shape, while discreet side pockets add everyday functionality. The maxi length elongates the silhouette, making it suitable for warm days or layered evening styling.\n\nCrafted from mid weight stretch fabric, this piece offers comfort and flexibility while maintaining structure and shape.\n\nDetails\n\n• Original Nuvula Golden Garden botanical print\n• 95% cotton poly, 5% spandex\n• Mid weight stretch fabric\n• U neckline\n• Sleeveless silhouette\n• Side pockets\n• Maxi length\n• Designed for a normal, easy fit\n\nCare\n\n• Machine wash cold\n• Hang to dry\n \n\nInches\n              XS     S       M     L      XL     2XL \nLength 49.6 50.8 52.0 53.1 54.3 55.5 \nBust     32.3 33.9 35.4 37.8 40.2 42.5 \nWaist    31.1 32.7 34.3 36.6 39.0 41.3 \n \n\nCentimeters\n               XS S M L XL 2XL \nLength 126.0 129.0 132.0 135.0 138.0 141.0 \nBust 82.0 86.0 90.0 96.0 102.0 108.0 \nWaist 79.0 83.0 87.0 93.0 99.0 105.0 \n \n\n \n",
  tags: [],
  msrpDollars: 178,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:02.451Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
